import { apiGet, apiPost } from '@/shared/utils/requestBuilder';

import type {
  ArbitralChatListPage,
  ArbitralChatMensagemDto,
  InternalChatHistoryResult,
  InternalChatMensagem,
} from '../../types';
import { mapArbitralChatMensagem, mapArbitralChatPage } from '../../utils/mapArbitralChatMensagem';
import { jsonOk } from '../jsonOk';

const listPage = async (
  processoId: string,
  page: number,
  limit: number,
): Promise<ArbitralChatListPage> => {
  const response = await apiGet(`/admin/arbitral/processos/${processoId}/chat`, { page, limit });
  const data = await jsonOk<ArbitralChatListPage>(response, 'Erro ao carregar o chat do processo');
  return {
    mensagens: data.mensagens ?? [],
    total: data.total ?? 0,
    page: data.page ?? page,
    limit: data.limit ?? limit,
  };
};

export const internoChatService = {
  history: async (input: {
    processoId: string;
    conversaId: string;
    empresaId: string;
    cursor?: string;
    limit?: number;
  }): Promise<InternalChatHistoryResult> => {
    const limit = input.limit ?? 50;
    if (input.cursor) {
      const page = Math.max(1, Number(input.cursor) || 1);
      const data = await listPage(input.processoId, page, limit);
      return mapArbitralChatPage(data, input.conversaId, input.empresaId);
    }
    const probe = await listPage(input.processoId, 1, limit);
    const lastPage = Math.max(1, Math.ceil(probe.total / (probe.limit || limit)) || 1);
    const data = lastPage === 1 ? probe : await listPage(input.processoId, lastPage, limit);
    return mapArbitralChatPage({ ...data, page: lastPage }, input.conversaId, input.empresaId);
  },

  send: async (input: {
    processoId: string;
    conversaId: string;
    empresaId: string;
    texto: string;
    file?: File;
  }): Promise<InternalChatMensagem> => {
    const form = new FormData();
    if (input.texto.trim()) form.append('texto', input.texto.trim());
    if (input.file) form.append('arquivos', input.file);
    const response = await apiPost(`/admin/arbitral/processos/${input.processoId}/chat`, form);
    const dto = await jsonOk<ArbitralChatMensagemDto>(response, 'Erro ao enviar mensagem');
    return mapArbitralChatMensagem(dto, input.conversaId, input.empresaId);
  },
};
